import { NotificationPrefType } from '@/features/settings/types';

export const isEnabledPref = (
  notificationPrefs: NotificationPrefType[],
  key: string,
): boolean => {
  const notificationPref = notificationPrefs.find((notification) => notification.name === key);
  if (notificationPref) {
    return notificationPref.show;
  }
  return false;
};
